// extracted by mini-css-extract-plugin
module.exports = {"container":"TimelineNavigationMobile_container__2CSN0","decade":"TimelineNavigationMobile_decade__1iC1q","current":"TimelineNavigationMobile_current__1ibI6"};